import { TAG_SETS } from "@/components/ui/tags/CommonTagChips";

/**
 * Tag sets for ticket templates
 */
export const ticketTemplateTagSets = {
  TICKET: TAG_SETS.TICKET,
};
